// import { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Phone, Mail, Briefcase } from 'lucide-react';
// import { CiLinkedin } from 'react-icons/ci';
// import { GiWaterDrop } from 'react-icons/gi';
// import { QRCodeCanvas } from 'qrcode.react';
// import { QRCode } from 'react-qrcode-logo';

// import API_ENDPOINTS from '../config/apiConfig';
// import axiosAuth from '../api/axiosAuth';

// export default function EmployeeDetail() {
//     const { id } = useParams();
//     const [employee, setEmployee] = useState(null);
//     const [isImageOpen, setIsImageOpen] = useState(false);
//     const navigate = useNavigate();

//     useEffect(() => {
//         axiosAuth
//             .get(API_ENDPOINTS.EMPLOYEE_DETAIL(id))
//             .then((res) => setEmployee(res.data))
//             .catch((err) => {
//                 console.error(err);
//                 navigate('/');
//             });
//     }, [id]);

//     if (!employee) {
//         return (
//             <p className="p-6 text-center text-gray-400">Loading...</p>
//         );
//     }

//     const employeeURL = `${window.location.origin}/employee/${id}`;
//     const logoUrl = '/wing red.png';

//     const downloadVCard = () => {
//         const vCardData = `
// BEGIN:VCARD
// VERSION:3.0
// FN:${employee.name}
// TITLE:${employee.designation}
// TEL;TYPE=CELL:${employee.contact_no}
// EMAIL:${employee.email}
// URL:${employee.linkedin_url}
// END:VCARD`.trim();

//         const blob = new Blob([vCardData], { type: 'text/vcard' });
//         const url = URL.createObjectURL(blob);
//         const a = document.createElement('a');
//         a.href = url;
//         a.download = `${employee.name.replace(/\s+/g, '_')}_contact.vcf`;
//         a.click();
//         URL.revokeObjectURL(url);
//     };

//     return (
//         <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-12 max-sm:py-5 px-4 flex justify-center items-start">

//             {/* Main Container */}
//             <div className="relative w-full max-w-3xl">

//                 {/* Neon Glow */}
//                 <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] h-full max-h-[90%] rounded-3xl bg-purple-900 opacity-30 blur-2xl z-0 pointer-events-none" />

//                 {/* Glassmorphism Content */}
//                 <div className="relative z-10 bg-white/0 backdrop-blur-lg rounded-3xl shadow-2xl border border-white/20 p-6 sm:p-10 space-y-10">

//                     {/* Banner */}
//                     <div
//                         className="relative w-full h-64 sm:h-80 md:h-96 rounded-3xl overflow-hidden shadow-purple-800 shadow-2xl group cursor-pointer"
//                         onClick={() => setIsImageOpen(true)}
//                     >
//                         <img
//                             src={employee.profile_pic || 'https://via.placeholder.com/800x400'}
//                             alt={employee.name}
//                             className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
//                         />
//                         <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/0 to-transparent z-10" />
//                         <div className="absolute bottom-4 left-4 z-20 text-white">
//                             <h2 className="text-3xl sm:text-4xl font-bold">{employee.name}</h2>
//                             <p className="mt-1 flex items-center text-blue-300 text-lg font-medium">
//                                 <Briefcase className="w-5 h-5 mr-2" />
//                                 {employee.designation}
//                             </p>
//                         </div>
//                     </div>

//                     {/* About Section */}
//                     <section className="text-center">
//                         <h3 className="text-xl font-semibold text-white/90 mb-2">About</h3>
//                         <p className="text-gray-300 text-justify leading-relaxed max-w-xl mx-auto">
//                             {employee.short_intro}
//                         </p>
//                     </section>

//                     {/* Contact Info */}
//                     <section>
//                         <h3 className="text-xl font-semibold text-white/90 mb-4 text-center">Contact Info</h3>
//                         <div className="grid sm:grid-cols-2 gap-5 text-gray-200">
//                             <div className="flex items-center gap-3">
//                                 <Phone className="w-5 h-5 text-blue-400" />
//                                 <a href={`tel:${employee.contact_no}`} className="hover:underline">
//                                     {employee.contact_no}
//                                 </a>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <Mail className="w-5 h-5 text-blue-400" />
//                                 <a href={`mailto:${employee.email}`} className="hover:underline">
//                                     {employee.email}
//                                 </a>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <CiLinkedin className="w-6 h-6 text-blue-400" />
//                                 <a
//                                     href={employee.linkedin_url || '#'}
//                                     target="_blank"
//                                     rel="noreferrer"
//                                     className="hover:underline"
//                                 >
//                                     LinkedIn
//                                 </a>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <GiWaterDrop size={20} className="text-red-500" />
//                                 <span>{employee.blood_group || 'Not Provided'}</span>
//                             </div>
//                         </div>
//                     </section>

//                     {/* QR Code */}
//                     {/* <section className="text-center mt-6">
//                         <h3 className="text-xl font-semibold text-white/90 mb-2">Scan My Contact</h3>
//                         <div className="inline-block p-4 bg-white rounded-xl">
//                             <QRCodeCanvas value={employeeURL} size={150} />
//                         </div>
//                     </section> */}


//                     <section className="text-center mt-6">
//                         <h3 className="text-xl font-semibold text-white/90 mb-2">Scan My Contact</h3>
//                         <div className="inline-block p-4 bg-white rounded-xl">
//                             <QRCode
//                                 value={employeeURL}
//                                 size={500}
//                                 logoImage={logoUrl}
//                                 logoWidth={250}
//                                 logoHeight={250}
//                                 qrStyle="dots" // Optional: "squares" or "dots"
//                                 eyeRadius={5}     // Optional: rounded corners
//                                 logoOpacity={0.8}
//                             />
//                         </div>
//                     </section>

//                     {/* Add Contact Button */}
//                     <div className="flex flex-col items-center mt-6">
//                         <button
//                             onClick={downloadVCard}
//                             className="bg-purple-800 text-white px-6 py-2 rounded-full font-semibold transition"
//                         >
//                             Add Contact
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             {/* Image Modal */}
//             {isImageOpen && (
//                 <div
//                     className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
//                     onClick={() => setIsImageOpen(false)}
//                 >
//                     <img
//                         src={employee.profile_pic}
//                         alt={employee.name}
//                         className="max-w-full max-h-[90vh] rounded-xl border-4 border-white shadow-2xl"
//                         onClick={(e) => e.stopPropagation()}
//                     />
//                 </div>
//             )}
//         </div>
//     );
// }




import { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Phone, Mail, Briefcase } from 'lucide-react';
import { CiLinkedin } from 'react-icons/ci';
import { GiWaterDrop } from 'react-icons/gi';
// import { QRCode } from 'react-qrcode-logo';

import API_ENDPOINTS from '../config/apiConfig';
import axiosAuth from '../api/axiosAuth';

export default function EmployeeDetail() {
    const { id } = useParams();
    const [employee, setEmployee] = useState(null);
    const [isImageOpen, setIsImageOpen] = useState(false);
    const navigate = useNavigate();
    // const qrRef = useRef(null); // For QR download

    useEffect(() => {
        axiosAuth
            .get(API_ENDPOINTS.EMPLOYEE_DETAIL(id))
            .then((res) => setEmployee(res.data))
            .catch((err) => {
                console.error(err);
                navigate('/');
            });
    }, [id]);

    if (!employee) {
        return (
            <p className="p-6 text-center text-gray-400">Loading...</p>
        );
    }

    // const employeeURL = `${window.location.origin}/employee/${id}`;
    // const logoUrl = '/wing red.png';

    const downloadVCard = () => {
        const vCardData = `
BEGIN:VCARD
VERSION:3.0
FN:${employee.name}
TITLE:${employee.designation}
TEL;TYPE=CELL:${employee.contact_no}
EMAIL:${employee.email}
URL:${employee.linkedin_url}
END:VCARD`.trim();

        const blob = new Blob([vCardData], { type: 'text/vcard' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${employee.name.replace(/\s+/g, '_')}_contact.vcf`;
        a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-12 max-sm:py-5 px-4 flex justify-center items-start">

            <div className="relative w-full max-w-3xl">
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] h-full max-h-[90%] rounded-3xl bg-purple-900 opacity-30 blur-2xl z-0 pointer-events-none" />

                <div className="relative z-10 bg-white/0 backdrop-blur-lg rounded-3xl shadow-2xl border border-white/20 p-6 sm:p-10 space-y-10">

                    {/* Banner */}
                    <div
                        className="relative w-full h-64 sm:h-80 md:h-96 rounded-3xl overflow-hidden shadow-purple-800 shadow-2xl group cursor-pointer"
                        onClick={() => setIsImageOpen(true)}
                    >
                        <img
                            src={employee.profile_pic || 'https://via.placeholder.com/800x400'}
                            alt={employee.name}
                            className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/0 to-transparent z-10" />
                        <div className="absolute bottom-4 left-4 z-20 text-white">
                            <h2 className="text-3xl sm:text-4xl font-bold">{employee.name}</h2>
                            <p className="mt-1 flex items-center text-blue-300 text-lg font-medium">
                                <Briefcase className="w-5 h-5 mr-2" />
                                {employee.designation}
                            </p>
                        </div>
                    </div>

                    {/* About Section */}
                    <section className="text-center">
                        <h3 className="text-xl font-semibold text-white/90 mb-2">About</h3>
                        <p className="text-gray-300 text-justify leading-relaxed max-w-xl mx-auto">
                            {employee.short_intro}
                        </p>
                    </section>

                    {/* Contact Info */}
                    <section>
                        <h3 className="text-xl font-semibold text-white/90 mb-4 text-center">Contact Info</h3>
                        <div className="grid sm:grid-cols-2 gap-5 text-gray-200">
                            <div className="flex items-center gap-3">
                                <Phone className="w-5 h-5 text-blue-400" />
                                <a href={`tel:${employee.contact_no}`} className="hover:underline">
                                    {employee.contact_no}
                                </a>
                            </div>
                            <div className="flex items-center gap-3">
                                <Mail className="w-5 h-5 text-blue-400" />
                                <a href={`mailto:${employee.email}`} className="hover:underline">
                                    {employee.email}
                                </a>
                            </div>
                            <div className="flex items-center gap-3">
                                <CiLinkedin className="w-6 h-6 text-blue-400" />
                                <a
                                    href={employee.linkedin_url || '#'}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="hover:underline"
                                >
                                    LinkedIn
                                </a>
                            </div>
                            <div className="flex items-center gap-3">
                                <GiWaterDrop size={20} className="text-red-500" />
                                <span>{employee.blood_group || 'Not Provided'}</span>
                            </div>
                        </div>
                    </section>

                    {/* QR Code with Logo */}
                    {/* <section className="text-center mt-6">
                        <h3 className="text-xl font-semibold text-white/90 mb-2">Scan My Contact</h3>
                        <div className="inline-block p-4 bg-white rounded-xl">
                            <QRCode
                                ref={qrRef}
                                value={employeeURL}
                                size={500}
                                logoImage={logoUrl}
                                logoWidth={250}
                                logoHeight={250}
                                qrStyle="dots"
                                eyeRadius={5}
                                logoOpacity={0.8}
                            />
                        </div>
                    </section> */}

                    {/* Buttons */}
                    <div className="flex flex-col items-center mt-6 space-y-3">
                        <button
                            onClick={downloadVCard}
                            className="bg-purple-800 text-white px-6 py-2 rounded-full font-semibold transition"
                        >
                            Add Contact
                        </button>
                    </div>
                </div>
            </div>

            {/* Image Modal */}
            {isImageOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
                    onClick={() => setIsImageOpen(false)}
                >
                    <img
                        src={employee.profile_pic}
                        alt={employee.name}
                        className="max-w-full max-h-[90vh] rounded-xl border-4 border-white shadow-2xl"
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}
        </div>
    );
}
